import dayjs from 'dayjs';
import { resolvedBaseUrl } from '../api/client';

const backendHost = resolvedBaseUrl.replace(/\/api\/v\d+\/?$/, '');

export const resolveFileUrl = (url) => {
  if (!url) return '';
  if (/^(https?:|blob:|data:)/.test(url)) return url;
  return `${backendHost}${url}`;
};

export const formatDate = (date, format = 'DD MMM YYYY') => {
  if (!date) { return '-'; }
  return dayjs(date).format(format);
};

export const formatDateTime = (date) => formatDate(date, 'DD MMM YYYY HH:mm');

export const calculateAge = (dob) => {
  if (!dob) { return '-'; }
  return dayjs().diff(dayjs(dob), 'year');
};

export const getInitials = (name = '') => {
  return name.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2);
};

export const formatPhone = (phone) => {
  if (!phone) { return '-'; }
  return phone.replace(/(\d{5})(\d{5})/, '$1 $2');
};

export const buildQueryString = (params) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      query.append(key, value);
    }
  });
  return query.toString();
};

export const downloadExcelTemplate = (headers, filename = 'template.xlsx') => {
  import('xlsx').then((XLSX) => {
    const ws = XLSX.utils.aoa_to_sheet([headers]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, filename);
  });
};

export const truncateText = (text, maxLength = 50) => {
  if (!text || text.length <= maxLength) { return text; }
  return `${text.slice(0, maxLength)}...`;
};

export const getApiErrorMessage = (err) => {
  if (err?.errors?.length) {
    return err.errors.map((e) => e.message).join('; ');
  }
  return err?.message || 'Something went wrong';
};
